<template>
    <div>
        <Header :cartAmount='cart.length'></Header>
        <div class='contents'>
            <router-view v-if='cartLoaded' :cartMap='cartMap' :cart='cart' />
        </div>
    </div>
</template>

<script>

import Header from '@/components/photobuy/Header.vue'

export default {
    name: 'PhotoGrapher',
    components: {
        Header
    },
    data () {
        return {
            cartAmount: 0,
            cart: [],
            cartLoaded: false
        }
    },
    computed: {
        cartMap () {
            let map = {}
            this.cart.forEach((photo) => {
                map[photo.id] = photo
            })

            return map
        }
    },
    created () {
        this._cartSaveQueue = Promise.resolve()
        this._cartSaveErrorNotified = false
        this._cartLoading = false

        this.$root.$on('cartIn', this.cartIn)
        this.$root.$on('cartLoad', this.cartLoad)
        this.$root.$on('changePhoto', this.changePhoto)
        this.$root.$on('cartReplace', this.cartReplace)
        this.$root.$on('cartClear', this.cartClear)
        window.addEventListener('focus', this.cartLoad)
        document.addEventListener('visibilitychange', this.cartVisibilityChange)

        this.cartLoad()
    },
    beforeDestroy () {
        this.$root.$off('cartIn', this.cartIn)
        this.$root.$off('cartLoad', this.cartLoad)
        this.$root.$off('changePhoto', this.changePhoto)
        this.$root.$off('cartReplace', this.cartReplace)
        this.$root.$off('cartClear', this.cartClear)
        window.removeEventListener('focus', this.cartLoad)
        document.removeEventListener('visibilitychange', this.cartVisibilityChange)
    },
    methods: {
        normalizeCart (value) {
            if (!Array.isArray(value)) return []

            const result = []
            const ids = {}
            value.forEach((photo) => {
                const id = Number(photo && photo.id)
                const length = Number(photo && photo.length)
                const size = photo && typeof photo.size === 'string' ? photo.size : ''
                if (!Number.isInteger(id) || id <= 0 || !size) return
                if (!Number.isInteger(length) || length < 1 || length > 99) return
                if (ids[id]) return

                ids[id] = true
                result.push({ id, size, length })
            })
            return result
        },
        localCart () {
            try {
                return this.normalizeCart(JSON.parse(localStorage.getItem('cart') || '[]'))
            } catch (e) {
                return []
            }
        },
        setCart (cart) {
            this.cart = this.normalizeCart(cart)
            localStorage.setItem('cart', JSON.stringify(this.cart))
        },
        async cartLoad () {
            if (this._cartLoading) return
            this._cartLoading = true

            await this._cartSaveQueue.catch(() => {})
            const localCart = this.localCart()

            try {
                const res = await this.axios.get(`${process.env.API_URL}/photobuy/cart`)
                const serverCart = this.normalizeCart(res.data.cart)

                if (res.data.initialized) {
                    this.setCart(serverCart)
                } else if (localCart.length) {
                    this.setCart(localCart)
                    await this.cartSave()
                } else {
                    this.setCart([])
                    await this.cartSave()
                }
            } catch (e) {
                this.setCart(localCart)
                this.$root.$emit('notification', 'is-warning', '共有カートを読み込めなかったため、この端末のカートを表示しています')
            } finally {
                this.cartLoaded = true
                this._cartLoading = false
            }
        },
        cartVisibilityChange () {
            if (document.visibilityState === 'visible') this.cartLoad()
        },
        cartIn (photo) {
            const index = this.cartIndexOf(photo.id)
            if (index === -1 && photo.size) {
                this.cart.push({ id: Number(photo.id), size: photo.size, length: Number(photo.length) || 1 })
                this.cartSave()
                this.$root.$emit('notification', 'is-primary', '選択した写真をカートに追加しました')
            } else if (index >= 0) {
                this.cart.splice(index, 1)
                this.cartSave()
                this.$root.$emit('notification', 'is-danger', '選択した写真をカートから削除しました')
            }
        },
        changePhoto (photo) {
            const index = this.cartIndexOf(photo.id)
            if (index < 0) return

            if (photo.size) this.cart[index].size = photo.size
            if (photo.length) this.cart[index].length = Number(photo.length)
            this.cartSave()
        },
        cartReplace (cart) {
            this.setCart(cart)
            this.cartSave()
        },
        cartClear () {
            this.setCart([])
            this.cartSave()
        },
        cartSave () {
            const cart = this.normalizeCart(this.cart)
            localStorage.setItem('cart', JSON.stringify(cart))

            this._cartSaveQueue = this._cartSaveQueue
                .catch(() => {})
                .then(() => this.axios.put(`${process.env.API_URL}/photobuy/cart`, { cart }))
                .then(() => {
                    this._cartSaveErrorNotified = false
                })
                .catch((e) => {
                    if (!this._cartSaveErrorNotified) {
                        this._cartSaveErrorNotified = true
                        this.$root.$emit('notification', 'is-warning', '共有カートを保存できませんでした。通信状態をご確認ください')
                    }
                    return null
                })

            return this._cartSaveQueue
        },
        cartIndexOf (id) {
            let result = -1
            this.cart.forEach((photo, i) => {
                if (Number(photo.id) === Number(id)) result = i
            })

            return result
        }
    }
}
</script>

<style scoped>

.contents {
    margin-top: 80px;
    display: flex;
}

@media (max-width: 600px) {
    .contents {
        margin-top: 0px;
    }
}

</style>



// WEBPACK FOOTER //
// src/routes/PhotoBuy.vue